import Cookies from "js-cookie";

// Google Analytics 4 with Consent Mode v2. Replaces gatsby-plugin-gdpr-cookies,
// whose `config` call auto-sent a page_view on top of its own page_view event,
// double-counting the first page of every visit.
//
// Nothing loads until the visitor accepts: gtag.js is only requested once the
// ml-cookie-consent cookie is "true". The /aicf (Astro) site reads the same
// cookie, so keep its name and values unchanged.

export const GA_MEASUREMENT_ID = "G-R88LJW809S";
export const CONSENT_COOKIE = "ml-cookie-consent";

// Same gate the plugin used (environments: ["production"]): `gatsby build`,
// not `gatsby develop`.
const enabled = process.env.NODE_ENV === "production";

let started = false;

function gtag() {
  window.dataLayer.push(arguments);
}

export function hasConsent() {
  return Cookies.get(CONSENT_COOKIE) === "true";
}

// `remember: false` stores a session cookie: the choice holds for this visit
// and the banner asks again once the browser is closed.
export function setConsent(granted, { remember = true } = {}) {
  Cookies.set(
    CONSENT_COOKIE,
    String(granted),
    remember ? { expires: 30 } : undefined,
  );
  if (granted) {
    // Re-accepted after withdrawing on this page: gtag.js is already loaded.
    if (started)
      window.gtag("consent", "update", { analytics_storage: "granted" });
    startAnalytics();
    trackPageView();
  } else if (started) {
    // Withdrawn from Cookie settings: gtag.js is already loaded, so tell it to
    // stop. Nothing loads on the next page view without consent.
    window.gtag("consent", "update", { analytics_storage: "denied" });
  }
}

export function startAnalytics() {
  if (started || !enabled || typeof window === "undefined") return;
  started = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || gtag;

  window.gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  // The visitor has accepted analytics only; advertising stays denied.
  window.gtag("consent", "update", { analytics_storage: "granted" });

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

export function trackPageView() {
  if (!started) return;
  // react-helmet sets document.title after the route renders; wait a couple of
  // frames so page_title is the new page's, not the previous one's.
  requestAnimationFrame(() =>
    requestAnimationFrame(() =>
      window.gtag("event", "page_view", {
        page_location: window.location.href,
        page_title: document.title,
      }),
    ),
  );
}
